import { useState } from 'react';
import { View, Text, Image } from 'react-native';
import Modal from 'react-native-modal';
import { Pressable } from 'react-native';
import { useDispatch, useSelector } from 'react-redux';
import { HIDE_USER_CONTEXT_MODAL } from '@reduxLocal/actions/types';
import { DefaultRootState } from '@reduxLocal/persistState';
import React from 'react';
import { themeSelector } from '@reduxLocal/selectors/themeSelector';
import { Button, H2, Paragraph, YStack } from 'tamagui';
import AvatarHandler from '@components/Global/AvatarHandler/AvatarHandler';

const MessageSettings = ({ ...props }) => {
  const isVisible = useSelector((state: DefaultRootState) => state.modals.messageModal.userSettingsModal);
  const selectedProfile = useSelector((state: DefaultRootState) => state.modals.messageModal.userSettingsContent);
  const dispatch = useDispatch();
  const theme = themeSelector();

  return (
    <Modal
      animationIn={'bounceInDown'}
      animationInTiming={1000}
      animationOut={'slideOutUp'}
      isVisible={isVisible}
      coverScreen={false}
      hasBackdrop={true}
      backdropOpacity={.6}
      style={{ flex: 1, paddingVertical: "20%", gap: 20 }} >
      <YStack style={{ backgroundColor: '#ECECEC', borderRadius: 20, elevation: 1, shadowRadius: 10, flex: 1, flexDirection: 'column', padding: 15 }}>
        <View style={{ flex: 2.5 }}>
          <AvatarHandler avatar={selectedProfile?.avatar} avatarImageStyle={{ height: 200, width: 300 }} />
        </View>
        <YStack style={{ flex: 4 }} >
          <H2 textAlign='center' adjustsFontSizeToFit style={{ flex: 1, color: 'black', fontSize: 24, fontWeight: "bold" }}>{selectedProfile ? selectedProfile.name + ' ' + selectedProfile.surname : null}</H2>
          <Paragraph textAlign='center' adjustsFontSizeToFit style={{ flex: 1, color: 'black', fontSize: 24 }}>{selectedProfile ? selectedProfile.department : null}</Paragraph>
          <Paragraph textAlign='center' adjustsFontSizeToFit style={{ flex: 1, color: 'black', fontSize: 24 }}>{selectedProfile ? selectedProfile.description : null}</Paragraph>
        </YStack>
      </YStack>
        <Button
          onPress={() => { dispatch({ type: HIDE_USER_CONTEXT_MODAL }) }}
        >
          Back
      </Button>
    </Modal>
  )
}

export default MessageSettings; 